<template>
    <div class="newsletter">
        <b-container fluid>
            <b-row>
                <b-col>
                    <h3>Newsletter - Sentenze Amministrative</h3>
                </b-col>
            </b-row>
            <b-row class="sfondo-giustup">
                <b-col class="text-center mb-3 mt-2">
                    <b>Aggiungi i parametri di ricerca per i quali desideri ricevere un'email periodica con le ultime sentenze inserite.</b>
                </b-col>
            </b-row>
            <b-row class="sfondo-giustup">
                <b-col>
                    Testo
                    <b-form-input class="text-center mt-3" placeholder="Testo della ricerca" v-model="form.testo" size="sm" type="text"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="sfondo-giustup">
                <b-col class="text-center mt-4">            
                    Sede
                </b-col>
            </b-row>
            <b-row class="sfondo-giustup">
                <b-col>            
                    <b-form-select v-model="form.sede" size="sm">
                        <template v-slot:first>
                            <option :value="``">Qualsiasi</option>
                        </template>
                        <option v-for="trib of data.sedi" :key="trib.key" :value="trib.key">{{trib.value}}</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="sfondo-giustup">
                <b-col class="mt-2 mb-2">            
                    <b-button variant="success" @click="addNewsletter()">Aggiungi alle newsletter</b-button>
                </b-col>
            </b-row>
            <hr />
            <b-row>
                <b-col class="text-center my-3">
                    <b>Iscrizioni attuali:</b>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="mt-2 mb-3">            
                    <b-table striped hover :items="newsletterTable.items" :fields="newsletterTable.fields" :show-empty="true" empty-text="Nessuna iscrizione alle newsletter!">
                        <template v-slot:cell(select)="data">
                            <b-button variant="danger" size="sm" @click="delNewsletter(data.item)">Elimina</b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import apiSearch from '../../services/search.js'
import api from '../../services/service.js'

export default {
  name: 'newsletter',
  data () {
    return {
        newsletterTable: {
            fields: [
                {
                    key: 'testoRicerca',
                    label: 'Testo',
                    sortable: true
                },
                {
                    key: 'sede',
                    label: 'Sede',
                    sortable: true
                },
                {
                    key: 'select',
                    label: '',
                    sortable: false
                }
            ],
            items: []
        },
        trattamento: true,
        data: {
            sedi: []
        },
        form: {
            sede: '',
            testo: ''
        }
    }
  },
  methods: {
    addNewsletter() {
        //check params
        let errMsg = null;
        if(!this.trattamento)
            errMsg = "Il consenso al trattamento dei dati è obbligatorio!";
        
        if(errMsg != null){
            alert(errMsg);
            return;
        }

        //send request      
        api.execute('post', 'newsletter/amministrative', this.form, true).then((data) => {
            if(data.status === 201){
                this.getNewsletters();
            }
            else {
                alert("Errore nell'inserimento della materia!");
            }
        });
    },
    async getNewsletters() {
        this.newsletterTable.items = await api.execute('get', 'newsletter/amministrative');
    },
    delNewsletter(item) {
        let data = {
            sede: item.sedeCodice,
            testo: item.testoRicerca
        };
        api.execute('post', 'newsletter/amministrative/elimina', data, true).then((data) => {
            if(data.status === 204){
                this.getNewsletters();
            }
            else {
                alert("Errore nell'eliminazione della materia!");
            }
        });
    },
    loadCampi(){
        let sede = this.$route.params.sede;
        if(sede !== undefined)
            this.form.sede = sede;

        let testo = this.$route.params.testo;
        if(testo !== undefined)
            this.form.testo = testo;
    }
  },
  async created() {
    this.data.sedi = await apiSearch.getSediAmministrative();
    
    await this.getNewsletters();
    this.loadCampi();

    this.$parent._data.loaded = true;
  },
  watch:{
    $route (to, from){
        if(to.name === "NewsletterAmministrative"){
            this.loadCampi();
        }
    }
  }
}
</script>

<style>

.sfondo-giustup {
  background-color: #008bc0;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Newsletter/NewsletterAmministrative.vue